import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { observer, inject } from 'mobx-react';
import styled from '@emotion/styled';
import * as DataList from 'components/DataList';
import EquipmentPage, { EquipmentPageSkeleton, equipmentName } from 'components/Equipment/EquipmentPage';

const PageWrapGray = styled('div')`
  padding: 12px;
  background-color: #F8FAFB;
  min-height: calc(100vh - 75px);
`

// An equipment's page (/dashboard/equipments/:id/show).
@inject('viewStore', 'equipmentStore') @observer
class EquipmentsShowPage extends Component {

  componentWillUnmount() {
    this.props.equipmentStore.clearSelectedEquipment();
  }

  retry = () => {
    const uuid = window.location.pathname.split('/').filter(Boolean).slice(-2)[0];
    this.props.equipmentStore.loadEquipment({ uuid });
  };

  // Equipment that doesn't exist (deleted, or a wrong link) gets a way back;
  // anything else (offline, server error) gets Try again.
  renderError() {
    const { equipmentStore: { equipment }, viewStore } = this.props;
    const missing = equipment.errorStatus === 404 || equipment.errorStatus === 403;
    const offline = typeof navigator !== 'undefined' && navigator.onLine === false;
    const back = { label: 'Back to equipment', icon: 'arrow-left', onClick: () => viewStore.equipments() };
    return (
      <div className="cp-error">
        {missing ? (
          <DataList.Notice
            icon="wrench"
            title="This equipment isn't here"
            message="It may have been deleted, or the link may be wrong. Find it in your equipment list instead."
            actions={[{ ...back, primary: true }]}
          />
        ) : (
          <DataList.Notice
            tone="error"
            icon={offline ? 'offline' : 'error'}
            role="alert"
            title="The equipment couldn't be loaded"
            message={offline ? "You're offline. Reconnect, then try again." : 'Something went wrong on our side. Try again in a moment.'}
            actions={[{ label: 'Try again', icon: 'refresh', onClick: this.retry, primary: true }, back]}
          />
        )}
      </div>
    );
  }

  render() {
    const { equipmentStore: { equipment: { isLoading, isError, object, errorStatus } } } = this.props;
    let content = null;
    let title;
    // Once shown, the equipment stays on screen while it reloads.
    if (object && object.id) {
      title = `${equipmentName(object.attributes)} | Field Nexus`;
      content = <EquipmentPage key={object.id} equipment={object} />;
    } else if (isError && !isLoading) {
      title = `${errorStatus === 404 ? 'Equipment not found' : "Couldn't load equipment"} | Field Nexus`;
      content = this.renderError();
    } else {
      title = 'Loading..';
      content = <EquipmentPageSkeleton />;
    }
    return (
      <div>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <PageWrapGray>
          {content}
        </PageWrapGray>
      </div>
    );
  }
}

export default EquipmentsShowPage;
